import { useQuery, useMutation } from '@tanstack/react-query';
import type {
  PropertyRatingSummary,
  PublicReview,
  SubmitReviewRequest,
  SubmitReviewResponse,
} from '@pms/shared';
import {
  getPropertyRating,
  getPropertyReviews,
  submitReview,
} from '../services/api/reviews.api';

/** Real aggregate rating for a property (cached by id). */
export function usePropertyRating(propertyId: string | undefined) {
  return useQuery<PropertyRatingSummary>({
    queryKey: ['property', propertyId, 'rating'],
    queryFn: () => getPropertyRating(propertyId as string),
    enabled: !!propertyId,
    staleTime: 60_000,
  });
}

/** Approved guest reviews for a property. */
export function usePropertyReviews(propertyId: string | undefined) {
  return useQuery<PublicReview[]>({
    queryKey: ['property', propertyId, 'reviews'],
    queryFn: () => getPropertyReviews(propertyId as string),
    enabled: !!propertyId,
    staleTime: 60_000,
  });
}

/** Submit a post-stay review (ref + PIN); mutation since input is user-supplied. */
export function useSubmitReview() {
  return useMutation<SubmitReviewResponse, unknown, SubmitReviewRequest>({
    mutationFn: (body) => submitReview(body),
  });
}
